<template>
  <div class="main-wrapper">
    <img src="../assets/positive.png" alt="Одобрено!" height="150px" />
    <p>Ваша заявка одобрена банком! Сотрудники банка скоро свяжутся с вами.</p>
  </div>
</template>

<script>
export default {
  name: "PositiveAnswerPage"
};
</script>

<style scoped>
</style>